<template>
  <div class="roleManage">
    <!-- 标题 -->
    <Title-Box :top-title="topTitle"></Title-Box>

    <ul class="tabBox boxs clearfix">
      <li v-for="(item,index) in tabData.textArr" @click="tabLi(index)" :class="{on:tabData.nowIndex == index}">{{item}}
      </li>
    </ul>

    <!-- tab会员管理 -->
    <div class="tabContent manageArea boxs" v-if="tabData.nowIndex == 0">
      <!-- tab会员管理-筛选框 -->
      <sr-filter class="searchBox" @search="handleSearch" @reset="handleReset">
        <template slot="otherCom">

          <el-form-item>
            <el-input
                    v-model="searchForm.memberName"
                    placeholder="输入角色名称"
                    @keyup.enter.native="handleSearch"
                    maxlength="30" size="medium" clearable
                    @input="e => searchForm.memberName = validForbid(e)"
            >
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-select v-model="searchForm.status"
                       placeholder="选择状态"
                       clearable filterable
            >
              <!-- <el-option label="无效" value="0"></el-option>
              <el-option label="有效" value="1"></el-option> -->
              <el-option
                      v-for="item in statusOptions"
                      :key="item.id"
                      :label="item.status"
                      :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

        </template>
      </sr-filter>

      <!-- tab会员管理-表格 -->
      <div class="botTable tableTheadGray boxs">
        <div class="tableTop">
          <span class="leTableTit">角色列表</span>
          <div class="rightBox">
            <!-- 添加角色按钮 -->
            <el-button @click="handleAddDialog()" class="greenBtn" icon="el-icon-plus" size="small">添加角色</el-button>
          </div>
        </div>
        <el-table :data="tableData"
                  ref="multipleTable"
                  style="width: 100%;"
                  max-height="600"
                  border
                  fit
                  highlight-current-row
                  tooltip-effect="dark"
                  @selection-change="selsChange"
                  @row-click="handleTableChange"
        >
          <!-- 这是列表前面的多选框 -->
          <!-- <el-table-column type="selection" align="center" width="35"></el-table-column> -->

          <el-table-column label="角色名称" prop="name" min-width="200" header-align="center" align="center"
                           show-overflow-tooltip>
          </el-table-column>

          <el-table-column label="备注" prop="note" min-width="200" header-align="center" align="center"
                           show-overflow-tooltip>
          </el-table-column>

          <!-- <el-table-column label="操作" fixed="right" width="150" header-align="center" align="center" show-overflow-tooltip> -->
          <el-table-column label="操作" fixed="right" width="200" header-align="center" align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button @click="showEditDialog(scope)" class="greenText"
                         type="text" title="编辑"
              >编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>

      </div>

    </div>

    <div class="tabContent mainBox boxs" v-if="tabData.nowIndex == 1">
      <!-- tab角色权限配置-左边 -->
      <div class="le_main boxs">
        <!-- 标题 -->
        <p class="titleBox boxs">
          <i class="roleIcon"></i>
          <span>角色列表</span>
        </p>

        <!-- tab角色列表 -->
        <div class="content roleBox boxs">
          <ul class="roleUlBox">
            <li v-for="(item,index) in roleData.roleArr" @click="changeRole(index, item)"
                :class="{on:roleData.roleIndex == index}">
              <i class="roleHead"></i>
              <span class="roleName">{{item.name}}</span>
            </li>
          </ul>
        </div>

      </div>

      <!-- tab角色权限配置-右边树 -->
      <div class="ri_main boxs">
        <!-- 标题+搜索框 -->
        <div class="topBox boxs">
          <span class="leTit">授权选项</span>
          <div class="riFilter">
            <el-button class="btn-search" @click="finallyAuth" size="small" title="提交授权">提交授权</el-button>
          </div>
        </div>

        <!-- 授权选项区域 -->
        <div class="treeContent boxs">
          <el-tree
                  :data="menuTreeData"
                  :props="defaultProps"
                  ref="tree"
                  :default-expand-all="true"
                  :default-checked-keys="selectedRole.menus"
                  node-key="id"
                  @node-click="authTreeClick"
                  :render-after-expand="defaultFalse"
                  highlight-current
                  show-checkbox
                  @check="onCheck"
                  @check-change="authTreeCheckChange"
                  @current-change="authCurrentCheckChange"
          >
          </el-tree>

        </div>

      </div>
    </div>


    <!-- 弹窗 -->
    <el-dialog width="460px" :title="dialogMap[dialogTitle]" :visible.sync="dialogFormVisible" @close="closeDialog"
               :before-close="beforeClose" :close-on-click-modal=false :show-close="false">
      <el-form ref="form" :rules="rules" :model="postForm" label-width="80px">

        <el-row>
          <el-col :span="24">
            <el-form-item label="角色名称" prop="name">
              <el-input
                      v-model="postForm.name"
                      placeholder="请输入角色名称"
                      maxlength="30" clearable
                      @input="e => postForm.name = validForbid(e)"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="角色备注" prop="note">
              <el-input
                      v-model="postForm.note"
                      placeholder="请输入角色备注"
                      maxlength="30" clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>

      <span slot="footer" class="dialog-footer flex-col">
                <div class="flex-row jus-c">
                    <button @click="beforeClose" class="butStyle cancelBtn">取 消</button>
                    <button @click="validateForm" class="butStyle refuseOBtn">确 定</button>
                </div>
            </span>

    </el-dialog>

  </div>
</template>


<script>
  import TitleBox from '@/components/Common/TitleBox/TitleBox.1';
  import SrFilter from '@/components/Common/Filter/Filter';

  import {
    listRolesAPI,
    addRoleAPI,
    updateRoleAPI,
    listRolesMenusAPI,
    addRolesMenusAPI
  } from '@/api/System/role.js'

  import {
    getMenuTreeAPI,
  } from '@/api/System/menu.js'

  // 弹窗的数据
  const defaultPostForm = {
    name: null,
    note: null,
  }

  // 搜索表格的条件-筛选栏
  const defaultSearchForm = {
    memberName: '', //会员名称
    memberType: '', //会员类型
    status: '', //状态：0禁用，1启用（0无效，1有效）
  }

  // 搜索表格的条件-筛选栏
  const defaultSelectMenu = {
    name: '无',
    id: '0',
  }

  // 搜索表格的条件-筛选栏
  const defaultAuthForm = {
    roleId: '',
    addMenuIds: [],
    delMenuIds: []
  }

  export default {
    name: "RoleManage",
    data() {
      // 会员账号格式校验(只能输入数字和英文字母)
      const validateCode = (rule, value, callback) => {
        if (!value) {
          // 会员账号不能为空
          return callback(new Error('请输入会员账号'))
        }
        // 会员账号不为空时校验格式
        const regex = /^[0-9A-Za-z]+$/
        if (regex.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入数字或英文字母'))
        }
      }
      return {
        selectedRole: {
          id: '',
          menus: []
        },

        // 提交授权表单
        submitAuthForm: Object.assign({}, defaultAuthForm),

        defaultFalse: true,
        nodeKey: 'id',

        defaultProps: {
          children: 'children',
          label: 'name', //模块名称
          labelId: 'id', //模块id
        },
        roleData: {
          roleArr: [],
          roleIndex: null,
        },

        // tab切换
        tabData: {
          textArr: ['角色管理', '角色权限配置'],
          nowIndex: 0
        },

        selectedItem: null,
        grandparentId: '',
        tableParams: {},
        //标题
        topTitle: {
          title: '角色管理',
          subTit: ''
        },

        // 表格搜索条件
        searchForm: Object.assign({}, defaultSearchForm),
        // 状态
        statusOptions: [
          {id: '0', status: '无效'},
          {id: '1', status: '有效'}
        ],
        // 表格数据
        tableData: [],
        // 表格已勾选数据
        checkedGouArrData: [],
        // 表格数据总数
        total: 0,
        // 表格勾选
        sels: [],
        // 批量选择下拉框
        batchOptions: [
          {label: '批量删除', value: 'del'},
        ],
        batchValue: '',


        // 弹窗数据
        postForm: Object.assign({}, defaultPostForm),
        // 添加/编辑窗口是否显示
        dialogFormVisible: false,
        // 弹窗标题
        dialogMap: {
          add: '添加角色',
          edit: '编辑会员'
        },
        dialogTitle: '',
        // 所属区域树窗口是否显示
        showMenuTree: false,
        // 区域树数据
        menuTreeData: [],
        // 区域树数据格式
        areaTreeProps: {
          children: 'children',
          label: 'name',
          labelId: 'id',
        },
        // 上级会员
        // 弹窗校验规则
        rules: {
          name: [{required: true, message: '请输入会员名称', trigger: 'blur'}],
        },
      }
    },
    components: {
      TitleBox,
      SrFilter
    },
    created() {
      // this.loadRoles()
      this.loadRoles()
    },
    methods: {
      onCheck(data, treeInfo) {
        console.log('tree', treeInfo)
        console.log('selectedRole.menus', this.selectedRole.menus)
        // 筛选出角色原来有的，现在没有的菜单id
        let checkedKeys = treeInfo.checkedNodes.filter(item => item.level == 3).map(item => item.id);
        console.log(checkedKeys)
        this.submitAuthForm.delMenuIds = this.selectedRole.menus.filter(item => !checkedKeys.includes(item))
        // 筛选出角色没有，现在有的菜单id
        this.submitAuthForm.addMenuIds = checkedKeys.filter(item => !this.selectedRole.menus.includes(item))
        // 取交集
        console.log('delMenuIds', this.submitAuthForm.delMenuIds)
        console.log('addMenuIds', this.submitAuthForm.addMenuIds)
      },
      resetAuthForm() {
        this.submitAuthForm.delMenuIds = []
        this.submitAuthForm.addMenuIds = []
      },
      resetChecked() {
        this.$refs.tree.setCheckedKeys([]);
      },

      async finallyAuth() {
        console.log(this.submitAuthForm)
        // return
        try {
          await addRolesMenusAPI(this.submitAuthForm)
          this.$message.success('授权成功')
          this.resetAuthForm()
          this.loadMenusByRole(this.selectedRole.id)
        } catch (e) {
          console.log(e);
        }
      },

      // 角色选择切换
      changeRole(index, role) {
        this.selectedRole.id = role.id
        // 先清空勾选的节点
        this.resetChecked()
        this.roleData.roleIndex = index;
        this.submitAuthForm.roleId = role.id
        this.loadMenusByRole(role.id)
        this.resetAuthForm()
      },
      // 授权树-当前被点击节点变化时触发的事件
      authCurrentCheckChange(data, checked, indeterminate) {
        // console.log('authCurrentCheckChange-data', data)
      },

      async loadMenusByRole(roleId) {
        try {
          const menus = await listRolesMenusAPI(roleId)
          const items = menus.data.map(item => item.menuId);
          this.selectedRole.menus = items

          setTimeout(() => {
            const checkedKeys = this.$refs.tree.getCheckedKeys();
            console.log(checkedKeys)
            const unchecked = checkedKeys.filter(item => !this.selectedRole.menus.includes(item));
            console.log(unchecked)
          }, 100)
        } catch (e) {
          console.log(e)
        }
      },

      // 授权树-节点勾选状态发生变化时的回调
      authTreeCheckChange(data, checked, indeterminate) {
        // console.log('submitAuthForm', this.submitAuthForm)
        // if (data.level == 3) {
        //   console.log('data', data)
        //   const checkedNodes = this.$refs.tree.getCheckedNodes(true);
        //   const checkedKeys = this.$refs.tree.getCheckedKeys(true);
        //   const halfCheckedKeys = this.$refs.tree.getHalfCheckedKeys();
        //   // console.log('halfCheckedKeys', halfCheckedKeys)
        //   console.log('checkedKeys', checkedKeys)
        //   // console.log('checkedNodes', checkedNodes)
        //   const selectedRoleMenus = this.selectedRole.menus
        //   console.log('this.selectedRole.menus', this.selectedRole.menus)
        //   let tmpList = []
        //   if (checked) {
        //     checkedNodes.forEach(item => {
        //       tmpList.push(item.id)
        //     })
        //     console.log('add tmpList', tmpList)
        //     const filter = tmpList
        //         .filter(item => !selectedRoleMenus.includes(item))
        //         .filter(item => item != 0);
        //     console.log('add filter', filter)
        //     this.submitAuthForm.addMenuIds = Array.from(new Set(filter));
        //   } else {
        //     checkedNodes.forEach(item => {
        //       tmpList.push(item.id)
        //     })
        //     console.log('del tmpList', tmpList)
        //     const filter = selectedRoleMenus
        //         .filter(item => !tmpList.includes(item))
        //         .filter(item => item != 0);
        //     console.log('del filter', filter)
        //     this.submitAuthForm.delMenuIds = Array.from(new Set(filter));
        //   }
        //   console.log(this.submitAuthForm)
        // }
      },

      // 获取弹窗区域树数据
      async getMenuTreeData() {
        try {
          const resp = await getMenuTreeAPI()
          // this.menuTreeData = resp.data
          this.menuTreeData = resp.data
        } catch (e) {
          console.log(e)
        }
      },

      async loadRoles() {
        try {
          const result = await listRolesAPI(this.tableParams);
          this.tableData = result.data
          this.roleData.roleArr = result.data
          return this.roleData.roleArr
        } catch (e) {
          console.log(e)
        }
      },


      // 授权树点击
      authTreeClick(data) {
        console.log(data)
        var checkedNodes = this.$refs.tree.getCheckedNodes();
        console.log(checkedNodes);
      },

      // 顶部菜单切换
      async tabLi(nowIndex) {
        // console.log(nowIndex)
        // 0:'角色管理', 1:'角色权限配置'
        this.tabData.nowIndex = nowIndex;
        console.log(this.tableData.nowIndex)
        if (this.tabData.nowIndex == 0) {
          this.loadRoles()
        } else if (this.tabData.nowIndex == 1) {
          const roles = await this.loadRoles()
          this.getMenuTreeData()
          this.changeRole(0, {id: roles[0].id})
        }
      },

      // 列表过滤查询
      handleSearch() {
        this.loadRoles()
      },
      // 搜索重置（清空）
      handleReset() {
        // 获取表格数据
        this.loadRoles()
      },

      // 列表勾选
      selsChange(val) {
        this.sels = val
      },
      // 点击表格某一行
      handleTableChange(row, event, column) {
      },
      // 批量处理
      batchOpt(value) {
        this.batchValue = value
      },
      // 批量处理确定按钮
      batchComfirm(value) {
        if (this.batchValue == 'del') {
          for (var i = 0; i < this.sels.length; i++) {
            if (this.sels[i].status == '1') {
              this.$message.error('所选包含“启用”状态的会员，请重新选择！')
              return
            }
          }
          // 批量删除
          var idDelGroups = this.sels.map(item => item.id).join(",")
          var delParams = {
            ids: idDelGroups
          }
          var $this = this
          this.$confirm('删除会员将无法恢复，确定操作吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            $this.delMember(delParams, '批量删除成功！')
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消批量删除操作'
            })
          })
        }

      },
      // 批量删除会员
      delMember(ids, msg) {
      },

      // 会员状态开关变化(change事件)
      statusChange(scope) {
        const statusParams = {
          id: scope.row.ID
        }
        // 变成0==注销事件
        if (scope.row.STATUS == '0') {

        } else if (scope.row.STATUS == '1') { // 变成1==启用事件
        }
      },
      // 区域树点击
      handleAddDialog() {
        this.dialogTitle = 'add'
        this.dialogFormVisible = true
      },
      showEditDialog(data) {
        this.dialogTitle = 'edit'
        this.dialogFormVisible = true

        this.postForm = JSON.parse(JSON.stringify(data.row))
      },

      // 弹窗关闭前
      beforeClose() {
        this.resetData()
      },

      // 关闭弹窗
      closeDialog() {
        this.resetData()
      },

      // 重置表单
      resetData() {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs['form'].clearValidate()
        })
        this.postForm = Object.assign({}, defaultPostForm)
      },

      // 验证表单-点击弹窗的“确定”按钮
      validateForm() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitForm()
          } else {
            this.dialogFormVisible = true
          }
        })
      },

      // 提交表单
      async submitForm() {
        if (this.dialogTitle === 'add') {
          this.addRole();
        } else if (this.dialogTitle === 'edit') {
          this.updateRole();
        }
      },

      // 添加角色
      async addRole() {
        try {
          const result = await addRoleAPI(this.postForm)
          this.$message.success('添加角色成功')
          this.closeDialog()
          this.loadRoles()
        } catch (e) {
          console.log(e)
        }
      },

      // 修改角色
      async updateRole() {
        try {
          const result = await updateRoleAPI(this.postForm)
          this.$message.success('修改角色成功')
          this.closeDialog()
          this.loadRoles()
        } catch (e) {
          console.log(e)
        }
      }
    }

  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  /* 文字顔色 */
  .greenText {
    color: #2DBAA5;
  }

  .lightGText {
    color: #76C819;
  }

  .orangeText {
    color: #FA6241;
  }

  .grayText {
    color: #7F7F7F;
  }

  // 批量操作
  .batchSel {
    width: 130px;
    margin-right: 5px;
  }

  .orangeBtn {
    color: #FFFFFF !important;
    background-color: #FA6241;

    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }

  // 按钮
  .el-button {
  }

  .greenBtn {
    color: #FFFFFF !important;
    background-color: #2DBAA5;

    &:hover {
      background-color: rgb(115, 196, 183);
    }
  }


  .roleManage {
    min-width: 1080px;
  }

  // tab切换-角色管理、角色权限配置
  .roleManage .tabBox {
    padding-left: 4px;
    background: #fff;
    height: 40px;
    line-height: 40px;
    text-align: center;
  }

  .tabBox li {
    float: left;
    width: 90px;
    color: #7F7F7F;
    font-size: 13px;
    font-weight: bold;
    cursor: pointer;
    position: relative;
  }

  .tabBox li + li {
    margin-left: 10px;
  }

  .tabBox li.on {
    color: #F99A1A;
  }

  .tabBox li:after {
    content: '';
    position: absolute;
    width: 90px;
    height: 4px;
    background: transparent;
    bottom: -4px;
    left: 0;
  }

  .tabBox li.on:after {
    background: #F99A1A;
  }


  // tab内容区
  .roleManage .tabContent {

  }

  // tab内容区-角色管理
  // 角色管理
  .roleManage .tabContent.manageArea {

  }

  // 角色管理-表格
  .roleManage .tabContent.manageArea .botTable {
    width: 100%;
    margin-top: 14px;
  }

  .botTable .tableTop {
    height: 54px;
    padding: 0 12px;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    border: 1px solid #EEEEEE;
    border-bottom: none;
  }

  .botTable .tableTop .leTableTit {
    font-size: 15px;
    font-weight: bold;
    color: #2B2727;
  }

  .botTable .tableTop .rightBox {
    width: auto;
    min-width: 200px; //考虑是否删去
    text-align: right;
    display: inline-block;
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-end;
  }


  // tab内容区-角色权限配置
  .roleManage .tabContent.mainBox {

  }

  .roleManage .tabContent.mainBox {
    width: 100%;
    margin-top: 20px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
  }

  // 角色权限配置-左边
  .mainBox .le_main {
    width: 312px;
    min-height: 616px;
    // min-height: 716px;
    height: 100%;
    background: #ffffff;
    padding: 12px 9px 8px 4px;
    display: flex;
    flex-flow: column nowrap;
  }

  .mainBox .le_main .titleBox {
    width: 100%;
    height: 17px;
    line-height: 17px;
    background: #fff;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    // align-items: center;
  }

  .mainBox .le_main .titleBox i.roleIcon {
    display: inline-block;
    margin-left: 6px;
    width: 16px;
    height: 16px;
    line-height: 16px;
    background: url('../../../assets/images/system/roleManage/roleIcon.png') no-repeat;
    background-size: 100% 100%;
  }

  .mainBox .le_main .titleBox span {
    margin-left: 4px;
    color: #4E4A46;
    font-size: 13px;
    font-weight: bold;
  }


  .mainBox .le_main .content {
    margin-top: 10px;
    width: 100%;
    height: 640px;
    min-height: 640px;
    max-height: 640px;
    background: #F5F5F5;
    border-radius: 3px;
    -moz-border-radius: 3px;
    -webkit-border-radius: 3px;
  }

  .mainBox .le_main .content.roleBox {
    padding-top: 8px;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: auto;
  }

  .roleBox .roleUlBox {
    width: 100%;
    height: 100%;
  }

  .roleBox .roleUlBox li {
    width: 100%;
    height: 24px;
    line-height: 24px;
    padding-left: 11px;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
  }

  .roleBox .roleUlBox li.on {
    background: #FAFAFA;
  }

  .roleBox .roleUlBox li + li {
    margin-top: 2px;
  }

  .roleBox .roleUlBox li i.roleHead {
    width: 16px;
    height: 16px;
    line-height: 16px;
    background: url('../../../assets/images/system/PersonnelManage/roleHeadOff.png') no-repeat;
    background-size: 100% 100%;
  }

  .roleBox .roleUlBox li.on i.roleHead {
    width: 16px;
    height: 16px;
    line-height: 16px;
    background: url('../../../assets/images/system/PersonnelManage/roleHeadOn.png') no-repeat;
    background-size: 100% 100%;
  }

  .roleBox .roleUlBox li span.roleName {
    width: calc(100% - 16px - 4px);
    margin-left: 4px;
    height: 16px;
    line-height: 16px;
    color: #4E4A46;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .roleBox .roleUlBox li.on span.roleName {
    color: #FA6241;
  }


  // 角色权限配置-右边
  .mainBox .ri_main {
    width: calc(100% - 312px - 12px);
    margin-left: 12px;
    min-width: 600px;
    height: auto;
    // height: 100%;
    background: #ffffff;
    padding: 6px 12px 8px;
    display: flex;
    flex-flow: column nowrap;
  }

  .mainBox .ri_main .topBox {
    width: 100%;
    height: auto;
    height: 32px;
    background: #fff;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    // align-items: center;

  }

  .mainBox .ri_main .topBox .leTit {
    margin-top: 9px;
    height: 17px;
    line-height: 17px;
    color: #4E4A46;
    font-size: 13px;
    font-weight: bold;
  }

  .mainBox .ri_main .topBox .riFilter {
    width: auto;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    align-items: center;
  }

  .mainBox .ri_main .topBox .riFilter .btn-search {
    margin-left: 5px;
    background-color: #FA6241;
    color: #fff;

    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }

  .mainBox .ri_main .treeContent {
    margin-top: 10px;
    width: 100%;
    // height: 100%;
    min-height: 640px;
    // max-height: 680px;
    background: #F5F5F5;
    border-radius: 3px;
    -moz-border-radius: 3px;
    -webkit-border-radius: 3px;
  }


  /* 分页条 */
  .pageBox {
    width: 100%;
    padding: 15px 0 10px;
    display: flex;
    justify-content: flex-end;
    background: #ffffff;
    border: 1px solid #E4E4E4;
    border-top: none;
    //   border-bottom-left-radius: 3px;
    //   border-bottom-right-radius: 3px;
  }

  /* 弹窗-分页条 */
  .pageBox2 {
    width: 100%;
    padding: 10px 0 10px 2px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;
    border: 1px solid #E4E4E4;
    border-top: none;
    //   border-bottom-left-radius: 3px;
    //   border-bottom-right-radius: 3px;
  }

  // 弹窗按钮-取消按钮
  .cancelBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 4px;
    background: #FFFFFF;
    color: #2B2727;
    color: #666666;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;

    &:hover {
      // background-color: #f1f1f1;
      border: 1px solid #d1d0d0;
    }
  }

  // 弹窗按钮-橙色按钮
  .refuseOBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    font-size: 14px;
    border-radius: 4px;
    background: #FA6241;
    color: #FFFFFF;

    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }


  // 弹窗筛选框
  .filtBox2 {
    margin: 0px 0px 10px 0px;
    padding: 0px;
    background: #ffffff;
    display: flex;
    flex-flow: row;
    justify-content: space-between;
  }

  .filtBox2 .el-form {
    width: 100%;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    padding-top: 18px;

    .el-input {
      // 原来的宽度
      width: 160px !important;
    }

    .el-select {
      // 原来的宽度
      width: 160px !important;
    }
  }

  .filtBox2 .btnArea {
    float: right;
  }

  .filtBox2 .el-button {
    border-radius: 4px;
    padding: 11px 15px;
    border: none;
  }

  .filtBox2 .btn-search {
    background-color: #FA6241;
    color: #fff;

    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }

  .filtBox2 .btn-reset {
    background-color: #F99A1A;
    color: #fff;

    &:hover {
      background-color: rgb(248, 186, 105);
    }
  }

</style>
